import React, { Component } from 'react';

class Home extends Component{

  render(){
    return(
      <h1>Hello world</h1>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/routes/Home.js